// extracted by mini-css-extract-plugin
export default {"menu":"NarrativeControl_menu__O5N9q","button":"NarrativeControl_button__AUVVh","permission":"NarrativeControl_permission__yQuvR","select-user":"NarrativeControl_select-user__1tPff"};